/**
 * Fill the gap in ShopifyAnalytics.meta.products.
 *
 * Shopify serialises at most 50 collection products into
 * `window.ShopifyAnalytics.meta.products`. Its shop_events_listener then scans
 * EVERY /cart/add form at window load and destructures the result of looking
 * the form's variant up in that list — unconditionally. Our collection
 * templates render more add-to-cart forms than 50 (assortment grid past the
 * cap + cross-sell products from other collections), so every excess form
 * threw "[shop_events_listener] Error in trackViewedProductVariant: Cannot
 * destructure property 'product' of findProductAndVariantInCollection(...)"
 * and silently lost its Viewed-Product-Variant attribution.
 *
 * card-product.liquid emits a <script type="application/json"
 * data-analytics-product> next to each quick-add form, mirroring the exact
 * entry shape Shopify uses. This file merges the missing ones in.
 *
 * Timing matters twice:
 *   - This file is deferred, so the initial sweep runs after parsing and
 *     before DOMContentLoaded — always before the load-time scan.
 *   - collection-assortment fetches its later pages via the Section
 *     Rendering API and appends more cards ASYNCHRONOUSLY. If such a
 *     fragment lands between DOMContentLoaded and `load`, a one-shot merge
 *     would miss it and the scan would still throw (observed: the /en page
 *     merged 54 of 62 because the page-2 fragment lost the race). The
 *     MutationObserver merges every inserted block as a MICROTASK of its
 *     insertion, so any form that exists when the load-scan task runs has
 *     already been merged. Blocks that arrive after `load` are merged too —
 *     harmless, and it keeps later scans (if any) consistent.
 *
 * On templates without meta.products (PDP uses meta.product, static pages
 * have neither) every merge is a no-op.
 */
(function () {
  'use strict';

  var SELECTOR = 'script[data-analytics-product]';
  var merged = new WeakSet();

  function mergeBlock(block) {
    if (merged.has(block)) return;
    merged.add(block);

    var meta = window.ShopifyAnalytics && window.ShopifyAnalytics.meta;
    if (!meta || !Array.isArray(meta.products)) return;

    var product;
    try { product = JSON.parse(block.textContent); } catch (e) { return; }
    if (!product || !product.id || !Array.isArray(product.variants)) return;

    var existing = null;
    for (var i = 0; i < meta.products.length; i++) {
      if (String(meta.products[i].id) === String(product.id)) { existing = meta.products[i]; break; }
    }
    if (!existing) {
      meta.products.push(product);
      return;
    }
    // Product already serialised, but Shopify may have truncated its variant
    // list too — add any variant the page's form uses.
    product.variants.forEach(function (v) {
      var present = existing.variants.some(function (ev) { return String(ev.id) === String(v.id); });
      if (!present) existing.variants.push(v);
    });
  }

  function sweep(root) {
    if (root.nodeType !== 1 && root.nodeType !== 9) return;
    if (root.matches && root.matches(SELECTOR)) mergeBlock(root);
    var blocks = root.querySelectorAll ? root.querySelectorAll(SELECTOR) : [];
    Array.prototype.forEach.call(blocks, mergeBlock);
  }

  // Initial DOM (defer ⇒ document is fully parsed at this point).
  sweep(document);

  // Async section fragments (assortment page 2+, quick-add refreshes, …).
  new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i++) {
      var added = mutations[i].addedNodes;
      for (var j = 0; j < added.length; j++) sweep(added[j]);
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
